import { getItem, setItem } from '@gig/magic-common';
import { __awaiter, __generator } from 'tslib';
import { VWO_INSTANCE } from '@gig/magic-messages';
import { v4 } from 'uuid';
import vwoSdk from 'vwo-node-sdk';

var getVariant = function (config) { return __awaiter(void 0, void 0, void 0, function () {
    var abUserId, id, settingsFile, vwoInstance, variant;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                abUserId = getItem('ab-user-id');
                if (!abUserId) {
                    id = v4();
                    abUserId = id;
                    setItem('ab-user-id', id);
                }
                return [4 /*yield*/, vwoSdk.getSettingsFile(config.accountId, config.sdkKey)];
            case 1:
                settingsFile = _a.sent();
                return [4 /*yield*/, vwoSdk.launch({ settingsFile: settingsFile })];
            case 2:
                vwoInstance = _a.sent();
                return [4 /*yield*/, vwoInstance.activate(config.campaignKey, "" + abUserId)];
            case 3:
                variant = _a.sent();
                window.eventBus.publish(VWO_INSTANCE, vwoInstance);
                return [2 /*return*/, variant];
        }
    });
}); };

export { getVariant };
